import "./CancelDrugOrder.css";
import { useLocation, useNavigate } from "react-router-dom";
import * as yup from "yup";
import { CreateHandleUnsaveNavigation } from "../../../../utilities/handleUnsaveNavigation";
import { useNavigationGuard } from "../../../../context/NavigationGuardProvider ";
import {
  Box,
  Dialog,
  DialogActions,
  Grid2,
  TextareaAutosize,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import CustomSwitch from "../../../../components/CustomSwitch/CustomSwitch";
import Loader from "../../../../components/Loader";
import {
  cancelOrderService,
  getCancelOrderOnLoadDataService,
} from "../../../../services/drugOrderManagementService";
import { notifySuccess } from "../../../../utilities/helper";
import CancelConfirmPage from "./CancelConfirmPage";

const messageStyle = {
  marginTop: "10px",
  color: "#867e7eff",
};

const CancelDrugOrder = () => {
  const id = useLocation()?.state?.id;

  const access_token = localStorage?.getItem("access_token");

  const [cancelOrderData, setCancelOrderData] = useState(null);
  const [cancelModal, setCancelModal] = useState({
    showCancelModal: false,
    cancelMessage: "",
  });
  const [load, setLoad] = useState(false);
  const [showConfirmPage, setShowConfirmPage] = useState(false);
  const [cancelConfirmData, setCancelConfirmData] = useState(null);

  const roleId = localStorage.getItem("roleId");

  const handleUnsaveNavigation = CreateHandleUnsaveNavigation();
  const navigate = useNavigate();

  const cancelDrugSchema = yup.object().shape({
    cancelOrder: yup.boolean(),
  });

  const {
    watch,
    handleSubmit,
    control,
    reset,
    formState: { errors, isDirty },
  } = useForm({
    resolver: yupResolver(cancelDrugSchema),
    defaultValues: {
      cancelOrder: false,
    },
  });

  const { cancelMessage, showCancelModal } = cancelModal;

  useNavigationGuard(isDirty);

  useEffect(() => {
    if (id) {
      getCancelDataOnLoad(id);
    }
  }, [id]);

  const getCancelDataOnLoad = async (orderId) => {
    setLoad(true);
    try {
      const res = await getCancelOrderOnLoadDataService(access_token, orderId);
      if (res?.data?.status == 200) {
        setLoad(false);
        setCancelOrderData(res?.data?.result);
      }
    } catch (err) {
      setLoad(false);
      console.log(err?.message);
      if (err?.status == 401) {
        navigate("/unauthorize");
      } else navigate("/drug-shipment-management");
    }
  };

  const submitCancelDrug = async (data) => {
    try {
      setLoad(true);
      const payload = {
        id: id,
        reasonOfCancellation: data?.cancelMessage === true ? "" : cancelMessage,
        cancelOrder: data?.cancelOrder,
      };
      const res = await cancelOrderService(access_token, payload, roleId);
      if (res?.data?.status == 200) {
        setLoad(false);
        notifySuccess("Order Cancelled Successfully");
        setCancelConfirmData(res?.data?.result);
        setShowConfirmPage(true);
        // navigate("/drug-shipment-management");
      } else if (
        res?.data?.message === "Cancellation flag is false in posted object!"
      ) {
        setLoad(false);
        notifySuccess("No Changes Made");
        navigate("/drug-shipment-management");
        setShowConfirmPage(false);
      }
    } catch (err) {
      setLoad(false);
      console.log("Error in submitting data", err);
      if (err?.status == 401) {
        navigate("/unauthorize");
      }
    }
  };

  useEffect(() => {
    watch((value) => {
      if (value?.cancelOrder === true) {
        setCancelModal({
          ...cancelModal,
          showCancelModal: true,
        });
      } else {
        setCancelModal({
          ...cancelModal,
          showCancelModal: false,
        });
      }
    });
  }, [watch]);

  return (
    <>
      {showConfirmPage ? (
        <CancelConfirmPage
          data={cancelConfirmData}
          setShowConfirm={setShowConfirmPage}
        />
      ) : (
        <>
          {load ? (
            <Loader />
          ) : (
            <div className="content-body">
              <p className="bread-crumbs-link-container">
                <button
                  className="bread-crumbs-btn"
                  onClick={(e) =>
                    handleUnsaveNavigation(e, isDirty, "", navigate)
                  }
                >
                  Home
                </button>{" "}
                |{" "}
                <button
                  className="bread-crumbs-btn"
                  onClick={(e) =>
                    handleUnsaveNavigation(
                      e,
                      isDirty,
                      "drug-shipment-management",
                      navigate
                    )
                  }
                >
                  Drug Order Management
                </button>{" "}
                |{" "}
                <button className="bread-crumbs-btn" to="/cancel-drug-order">
                  Cancel Order
                </button>
                -{" "}
                <b style={{ color: "gray" }}>
                  {localStorage?.getItem("studyName")}
                </b>
              </p>

              <Grid2
                container
                alignItems="center"
                justifyContent="space-between"
                sx={{ width: "100%", margin: "0 auto" }}
              >
                <Grid2 item md={4}>
                  <p className="page-heading">Cancel Order</p>
                </Grid2>
              </Grid2>

              <div>
                <div className="cancel-drug-main-heading">
                  Order Number #{cancelOrderData?.orderNumber}
                </div>
                <Box
                  component="form"
                  autoComplete="off"
                  sx={{
                    height: "auto",
                  }}
                  onSubmit={handleSubmit(submitCancelDrug)}
                >
                  <Grid2
                    container
                    alignItems="center"
                    justifyContent={"space-between"}
                    sx={{ width: "100%", margin: "0 auto" }}
                    gap={1}
                  >
                    <Grid2 size={{ xl: 12, md: 12, lg: 12, sm: 12, xs: 12 }}>
                      <div className="cancel-drug-detail-container">
                        <div className="cancel-drug-detail-name">
                          Order Date
                        </div>
                        <div className="cancel-drug-detail-value">
                          {cancelOrderData?.orderDate}
                        </div>
                      </div>
                    </Grid2>
                    <Grid2 size={{ xl: 12, md: 12, lg: 12, sm: 12, xs: 12 }}>
                      <div className="cancel-drug-detail-container">
                        <div className="cancel-drug-detail-name">
                          Order Source
                        </div>
                        <div className="cancel-drug-detail-value">
                          {cancelOrderData?.orderSource}
                        </div>
                      </div>
                    </Grid2>
                    <Grid2 size={{ xl: 12, md: 12, lg: 12, sm: 12, xs: 12 }}>
                      <div className="cancel-drug-detail-container">
                        <div className="cancel-drug-detail-name">
                          Order Destination
                        </div>
                        <div className="cancel-drug-detail-value">
                          {cancelOrderData?.destinationDepotId
                            ? cancelOrderData?.orderDestination
                            : `Site ${cancelOrderData?.orderDestination}`}
                        </div>
                      </div>
                    </Grid2>

                    <Grid2 size={{ xl: 12, md: 12, lg: 12, sm: 12, xs: 12 }}>
                      <div className="cancel-drug-detail-container">
                        <div className="cancel-drug-detail-name">Drug Kits</div>
                        <div className="cancel-drug-detail-value">
                          {cancelOrderData?.drugs
                            ?.map((item) => item?.drugKitNumber)
                            .join(" , ")}
                        </div>
                      </div>
                    </Grid2>

                    <Grid2 size={{ xl: 12, md: 12, lg: 12, sm: 12, xs: 12 }}>
                      <div className="cancel-drug-detail-container">
                        <div className="cancel-drug-detail-name">
                          Are you sure want to cancel this order ?{" "}
                          <span
                            style={{
                              color: "red",
                            }}
                          >
                            *
                          </span>
                        </div>
                        <div>
                          <div className="cancel-drug-detail-value">
                            <div className="drug-cancel-switch-container">
                              <span>No</span>
                              <Controller
                                name="cancelOrder"
                                control={control}
                                defaultValue={false} // or your actual initial value
                                render={({ field }) => (
                                  <CustomSwitch
                                    isSwitch={field.value}
                                    setSwitch={(val) => {
                                      field.onChange(val);
                                      if (val === false) {
                                        setCancelModal({
                                          showCancelModal: false,
                                          cancelMessage: "",
                                        });
                                      }
                                    }}
                                  />
                                )}
                              />
                              <span>Yes</span>
                            </div>
                          </div>
                          {errors.cancelOrder && (
                            <div className="error-container">
                              {errors.cancelOrder.message}
                            </div>
                          )}
                          {cancelMessage !== "" && !showCancelModal && (
                            <div style={messageStyle}>{cancelMessage}</div>
                          )}
                        </div>
                      </div>
                    </Grid2>
                  </Grid2>

                  <Grid2
                    alignItems={"end"}
                    justifyContent="end"
                    container
                    gap={3}
                    sx={{ marginTop: "2%" }}
                  >
                    <Grid2 item md={6}>
                      <button
                        type="button"
                        className="create-btn-outlined"
                        onClick={(e) => {
                          e.preventDefault();
                          handleUnsaveNavigation(
                            e,
                            isDirty,
                            "drug-shipment-management",
                            navigate
                          );
                        }}
                      >
                        Cancel
                      </button>
                    </Grid2>
                    <Grid2 item md={6}>
                      <button type="submit" className="create-btn">
                        Save
                      </button>
                    </Grid2>
                  </Grid2>
                </Box>
              </div>
            </div>
          )}

          {showCancelModal && (
            <Dialog
              open={showCancelModal}
              onClose={() =>
                setCancelModal({
                  ...cancelModal,
                  showCancelModal: false,
                })
              }
            >
              <div
                style={{
                  width: "450px",
                  padding: "20px",
                }}
              >
                <Typography id="modal-modal-title" variant="h6" component="h2">
                  Cancel Order
                </Typography>
                <TextareaAutosize
                  minRows={3}
                  type="text"
                  className="form-text-area"
                  style={{
                    margin: "10px 0px",
                  }}
                  placeholder="Reason For Cancelling Order"
                  onChange={(e) =>
                    setCancelModal({
                      ...cancelModal,
                      cancelMessage: e.target.value,
                    })
                  }
                ></TextareaAutosize>
              </div>
              <DialogActions>
                <button
                  className={
                    cancelMessage.trim().length == 0
                      ? "disabled-btn"
                      : "create-btn"
                  }
                  disabled={cancelMessage.trim().length == 0}
                  style={{ width: "120px" }}
                  onClick={() => {
                    setCancelModal({
                      ...cancelModal,
                      showCancelModal: false,
                    });
                  }}
                >
                  Save Message
                </button>
                <button
                  className="create-btn-outlined"
                  style={{ width: "120px" }}
                  onClick={() => {
                    setCancelModal({
                      showCancelModal: false,
                      cancelMessage: "",
                    });
                    reset({
                      cancelOrder: false,
                    });
                  }}
                >
                  Cancel
                </button>
              </DialogActions>
            </Dialog>
          )}
        </>
      )}
    </>
  );
};

export default CancelDrugOrder;
